import { CompletionTrackingState, createCompletionTrackingState } from './completionTrackingReducer';
import { createItemsTrackingReducer, ItemsTrackingState } from './itemsTrackingReducer';
import { createQuestionWidgetTrackingReducer, QuestionWidgetTrackingState } from './questionWidgetTrackingReducer';
import { createTrackedQuizState, TrackedQuizState } from './trackedQuizReducer';
import { combineReducers } from '@reduxjs/toolkit';

export type TrackingState = {
  items: ItemsTrackingState;
  questionWidget: QuestionWidgetTrackingState;
  completed: CompletionTrackingState;
  trackedQuiz: TrackedQuizState;
};

export function createTrackingState(
  startState: ItemsTrackingState,
  widgetStartState: QuestionWidgetTrackingState,
  completionState: CompletionTrackingState,
  trackedQuizState: TrackedQuizState
) {
  return combineReducers<TrackingState>({
    items: createItemsTrackingReducer(startState),
    questionWidget: createQuestionWidgetTrackingReducer(widgetStartState),
    completed: createCompletionTrackingState(completionState),
    trackedQuiz: createTrackedQuizState(trackedQuizState),
  });
}
